const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

/**
 * Servicio para obtener los días festivos activos.
 * Devuelve un array de festivos: { fecha, nombre, tipo, ... }
 */
export const getActiveHolidays = async () => {
  try {
    const response = await fetch(`${API_URL}/holidays/active`);
    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
    const result = await response.json();
    if (result?.state && Array.isArray(result?.data)) {
      return result.data;
    }
    return [];
  } catch (error) {
    console.error('Error fetching active holidays:', error);
    return [];
  }
};
